import { IPromoInfo } from '../../../types/newbuildingPromos';

interface IProvider {
  logoUrl: string;
  name: string;
}

export const getPromoProvider = (promo: IPromoInfo): IProvider => {
  if (promo.bank && promo.isFromBank) {
    return {
      name: promo.bank.name,
      logoUrl: promo.bank.secondSquareImageUrl || '',
    };
  }

  return {
    name: promo.authorName || '',
    logoUrl: promo.authorLogoUrl || '',
  };
};
